const de = {
  translation: {
    'Sign in credentials': 'Anmeldeinformationen',
    'Sign in': 'Einloggen',
    'Add Category': 'Kategorie hinzufügen',
    Title: 'Titel',
    Description: 'Beschreibung',
    Add: 'Hinzufügen',
    Remove: 'Löschen',
    'Add/Remove': 'Hinzufügen/Entfernen',
    Success: 'Erfolg',
    Danger: 'Achtung',
    Categories: 'Kategorien',
    Image: 'Bild',
    Header: 'Header',
    Loading: 'Wird geladen',
    Error: 'Error',
    Edit: 'Bearbeiten',
    Delete: 'Löschen',
    'Edit Category': 'Kategorie bearbeiten',
    Save: 'sparen',
    'OrderID prefix': 'OrderID-Präfix',
    Order: 'Auftrag',
    Email: 'Email',
    Password: 'Passwort',
    Enable: 'Aktivieren',
    Disable: 'Deaktivieren',
    'Enable/Disable': 'Aktivieren deaktivieren',
    Saving: 'Speichern',
    Paypal: 'Paypal',
    'Client ID': 'Kunden ID',
    'Client Secret': 'Kundengeheimnis',
    Sandbox: 'Sandkasten',
    'Publishable Key': 'Veröffentlichbarer Schlüssel',
    'Secret Key': 'Geheimer Schlüssel',
    'Delivery Charges': 'Versandkosten',
    Price: 'Preis',
    'Add Food': 'Lebensmittel hinzufügen',
    Category: 'Kategorie',
    Select: 'Wählen',
    Variations: 'Variationen',
    Type: 'Art',
    'Food Image': 'Food Image',
    Foods: 'Lebensmittel',
    Actions: 'Aktionen',
    'Edit Food': 'Essen bearbeiten',
    OrderID: 'Auftragsnummer',
    Orders: 'Aufträge',
    Name: 'Name',
    Items: 'Artikel',
    Payment: 'Zahlung',
    Status: 'Status',
    Review: 'Rezension',
    'Mark as': 'markieren als',
    Users: 'Benutzer',
    Phone: 'Telefon',
    Address: 'Adresse',
    2019: '2019',
    'About Us': 'Über uns',
    Blog: 'Blog',
    Welcome: 'Herzlich willkommen',
    Logout: 'Ausloggen',
    Dashboard: 'Instrumententafel',
    Configuration: 'Aufbau',
    Login: 'Anmeldung',
    Food: 'Essen',
    'Character limit of max length 50':
      'Zeichenbegrenzung von maximaler Länge 50',
    'Character limit of max length 15':
      'Zeichenbegrenzung von maximaler Länge 15',
    'Character limit of max length 60':
      'Zeichenbegrenzung von maximaler Länge 60',
    'Character limit of max length 20':
      'Zeichenbegrenzung von maximaler Länge 20',
    'Character limit of max length 140':
      'Zeichenbegrenzung von maximaler Länge 140',
    Currency: 'Währung',
    'Currency Code': 'Währungscode',
    'Currency Symbol': 'Währungszeichen'
  }
}

export default de
